import { shouldPolyfill as shouldPolyfillCanonicalLocales } from "@formatjs/intl-getcanonicallocales/should-polyfill";
import { shouldPolyfill as shouldPolyfillLocale } from "@formatjs/intl-locale/should-polyfill";
import { shouldPolyfill as shouldPolyfillNumbers } from "@formatjs/intl-numberformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillPlural } from "@formatjs/intl-pluralrules/should-polyfill";

import { LocalizationStore } from "./LocalizationStore";

const numberFormatForLocale = async (locale: string) => {
  const simplifiedLocale = locale.split("-")[0];

  switch (simplifiedLocale) {
    case "da":
      await import("@formatjs/intl-numberformat/locale-data/da");
      break;
    case "de":
      await import("@formatjs/intl-numberformat/locale-data/de");
      break;
    case "en":
      await import("@formatjs/intl-numberformat/locale-data/en");
      break;
    case "es":
      await import("@formatjs/intl-numberformat/locale-data/es");
      break;
    case "fr":
      await import("@formatjs/intl-numberformat/locale-data/fr");
      break;
    case "it":
      await import("@formatjs/intl-numberformat/locale-data/it");
      break;
    case "nl":
      await import("@formatjs/intl-numberformat/locale-data/nl");
      break;
    case "pt":
      await import("@formatjs/intl-numberformat/locale-data/pt");
      break;
    case "sv":
      await import("@formatjs/intl-numberformat/locale-data/sv");
      break;
  }
};

const pluralRulesForLocale = async (locale: string) => {
  const simplifiedLocale = locale.split("-")[0];

  switch (simplifiedLocale) {
    case "da":
      await import("@formatjs/intl-pluralrules/locale-data/da");
      break;
    case "de":
      await import("@formatjs/intl-pluralrules/locale-data/de");
      break;
    case "en":
      await import("@formatjs/intl-pluralrules/locale-data/en");
      break;
    case "es":
      await import("@formatjs/intl-pluralrules/locale-data/es");
      break;
    case "fr":
      await import("@formatjs/intl-pluralrules/locale-data/fr");
      break;
    case "it":
      await import("@formatjs/intl-pluralrules/locale-data/it");
      break;
    case "nl":
      await import("@formatjs/intl-pluralrules/locale-data/nl");
      break;
    case "pt":
      await import("@formatjs/intl-pluralrules/locale-data/pt");
      break;
    case "sv":
      await import("@formatjs/intl-pluralrules/locale-data/sv");
      break;
  }
};

/*
Because of the way that imports work we cannot use a function here and pass the path, the import
must be defined inline, which leads to some pretty ugly boilerplate.

These imports should not cause us to fail hard, in most circumstances
the majority of the site will continue to work.
 */
export const intlPolyfills = async () => {
  const differentLocaleForCurrency =
    LocalizationStore.get().locale !==
    LocalizationStore.get().currencyFormatLocale;

  if (shouldPolyfillLocale()) {
    await import("@formatjs/intl-locale/polyfill");
  }

  if (shouldPolyfillCanonicalLocales()) {
    await import("@formatjs/intl-getcanonicallocales/polyfill");
  }

  if (shouldPolyfillNumbers()) {
    await import("@formatjs/intl-numberformat/polyfill");
    await numberFormatForLocale(LocalizationStore.get().locale);
    if (differentLocaleForCurrency) {
      await numberFormatForLocale(LocalizationStore.get().currencyFormatLocale);
    }
  }

  if (shouldPolyfillPlural()) {
    await import("@formatjs/intl-pluralrules/polyfill");
    await pluralRulesForLocale(LocalizationStore.get().locale);
    if (differentLocaleForCurrency) {
      await pluralRulesForLocale(LocalizationStore.get().currencyFormatLocale);
    }
  }
};
